<template>
	<v-col class="ma-0 pa-0" cols="12">
		<template v-if="deviceStatusLoading == false">
			<v-col class="ma-0 pa-1 mb-8 pt-0 pl-5 pr-5" cols="12" id="cctv_status_box"
				v-if="authorities.GET_DASHBOARD || (checkRole == 'private' || checkRole == 'branch')">
				<v-row class="ma-0 pa-0" align="start">
					<v-col class="ma-0 pa-0" cols="4">
						<v-row class="ma-0 pa-0" align="center">
							<v-col id="chart_box" class="ma-0 pa-0" cols="4">
								<DoughnutChart :data="cctvChartData" :options="chartOptions" :plugins="chartPlugins"
									:width="100" :height="100"></DoughnutChart>
							</v-col>
							<v-col class="ma-0 pa-5 pl-0 pr-10" cols="8">
								<v-row class="ma-0 pa-0 pb-3" align="end" justify="space-between">
									<v-col class="ma-0 pa-0 pb-1" cols="auto">{{td('cctvCount')}}</v-col>
									<v-row class="ma-0 pa-0" align="end" justify="end">
										<v-col class="ma-0 pa-0" cols="auto"
											style="font-size:1.75rem;">{{totalCCTVCnt}}</v-col>
										<v-col class="ma-0 pa-0 pb-1 pl-1" cols="auto">{{td('ea')}}</v-col>
									</v-row>
								</v-row>
								<v-row class="ma-0 pa-0 pb-3" align="center" justify="space-between">
									<v-row class="ma-0 pa-0" align="center">
										<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
											src="@/assets/images/blue_box.png"></v-img>
										{{td('online')}}
									</v-row>
									<v-row class="ma-0 pa-0" align="end" justify="end">
										<v-col class="ma-0 pa-0" cols="auto"
											style="font-size:1.35rem;">{{deviceStatusData.uac.online}}</v-col>
										<v-col class="ma-0 pa-0 pb-1 pl-1" cols="auto">{{td('ea')}}</v-col>
									</v-row>
								</v-row>
								<v-row class="ma-0 pa-0" align="center" justify="space-between">
									<v-row class="ma-0 pa-0" align="center">
										<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
											src="@/assets/images/grey_box.png"></v-img>
										{{td('offline')}}
									</v-row>
									<v-row class="ma-0 pa-0" align="start" justify="end">
										<v-col class="ma-0 pa-0" cols="auto">{{deviceStatusData.uac.offline}}</v-col>
										<v-col class="ma-0 pa-0 pb-1 pl-1" cols="auto">{{td('ea')}}</v-col>
									</v-row>
								</v-row>
							</v-col>
						</v-row>
					</v-col>
					<v-col class="ma-0 pa-0" cols="4">
						<v-row class="ma-0 pa-0" align="center">
							<v-col id="chart_box" class="ma-0 pa-0" cols="4">
								<DoughnutChart :data="aiCameraChartData" :options="chartOptions" :plugins="chartPlugins"  
									:width="100" :height="100"></DoughnutChart>
							</v-col>
							<v-col class="ma-0 pa-5 pl-0 pr-10" cols="8">
								<v-row class="ma-0 pa-0 pb-3" align="end" justify="space-between">
									<v-col class="ma-0 pa-0 pb-1" cols="auto">{{td('alCameraCount')}}</v-col>
									<v-row class="ma-0 pa-0" align="end" justify="end">
										<v-col class="ma-0 pa-0" cols="auto"
											style="font-size:1.75rem;">{{totalAiCameraCnt}}</v-col>
										<v-col class="ma-0 pa-0 pb-1 pl-1" cols="auto">{{td('ea')}}</v-col>
									</v-row>
								</v-row>
								<v-row class="ma-0 pa-0 pb-3" align="center" justify="space-between">
									<v-row class="ma-0 pa-0" align="center">
										<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
											src="@/assets/images/blue_box.png"></v-img>
										{{td('online')}}
									</v-row>
									<v-row class="ma-0 pa-0" align="end" justify="end">
										<v-col class="ma-0 pa-0" cols="auto"
											style="font-size:1.35rem;">{{deviceStatusData.uas.online}}</v-col>
										<v-col class="ma-0 pa-0 pb-1 pl-1" cols="auto">{{td('ea')}}</v-col>
									</v-row>
								</v-row>
								<v-row class="ma-0 pa-0" align="center" justify="space-between">
									<v-row class="ma-0 pa-0" align="center">
										<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
											src="@/assets/images/grey_box.png"></v-img>
										{{td('offline')}}
									</v-row>
									<v-row class="ma-0 pa-0" align="start" justify="end">
										<v-col class="ma-0 pa-0" cols="auto">{{deviceStatusData.uas.offline}}</v-col>
										<v-col class="ma-0 pa-0 pb-1 pl-1" cols="auto">{{td('ea')}}</v-col>
									</v-row>
								</v-row>
							</v-col>
						</v-row>
					</v-col>
					<v-col class="ma-0 pa-0" cols="4">
						<v-row class="ma-0 pa-0" align="center">
							<v-col class="ma-0 pa-0" cols="4"></v-col>
							<v-col class="ma-0 pa-5 pl-0 pr-10" cols="8">
								<v-row class="ma-0 pa-0" align="end" justify="space-between">
									<v-col class="ma-0 pa-0 pb-1" cols="auto">{{td('storeCount')}}</v-col>
									<v-row class="ma-0 pa-0" align="end" justify="end">
										<v-col class="ma-0 pa-0" cols="auto"
											style="font-size:1.75rem;">{{deviceStatusData.storeCnt}}</v-col>
										<v-col class="ma-0 pa-0 pb-1 pl-1" cols="auto">{{td('store')}}</v-col>
									</v-row>
								</v-row>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</template>
		<template v-else>
			<v-col class="ma-0 mb-8 pa-3" cols="12" id="cctv_status_box"
				align="center">
				<ImageSkeleton :loaderCount="3" width='90%' height='126px' />
			</v-col>
		</template>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import DoughnutChart from "@/components/doughnutChart.js";
import ImageSkeleton from '@/components/loader/ImageSkeleton.vue';

export default {
	components: {
		DoughnutChart, ImageSkeleton
	},
	mixins: [mixin.common],
	data: () => ({
		checkRole: 'main',
		authorities: {},
		chartOptions: {
			maintainAspectRatio: false,
      responsive: false,
      legend: { display: false },
			cutoutPercentage: 70 // line 굵기
    },
		cctvChartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン", backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [0, 0],
					borderWidth: 0, borderColor: 'transparent', hoverOffset: 10
				}
			],
		},
		aiCameraChartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [0, 0],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		},
		chartPlugins: [
      {
        id: 'doughnut_chart_center_text',
        beforeDraw: (chart) => {
          const {ctx, data} = chart;
          ctx.save();
          let height = chart.height;
          let width = chart.width;
          ctx.restore();
          ctx.font = "1.4rem note-sans-jp-medium";
          ctx.fillStyle = "#fff";
          ctx.textBaseline = "middle";

          let cal = data.datasets[0].data[0] / (data.datasets[0].data[0] + data.datasets[0].data[1]);
			    let percentNum = isNaN(cal) ? '0' : Math.floor(cal * 100).toString();
          let percent = '%';
          let textNum = percentNum,
              text = percent,
              textNumX = Math.round((width - ctx.measureText(textNum).width * 1.5) / 2 ),
              textNumY = height / 2;
          ctx.fillText(textNum, textNumX, textNumY);
          ctx.font = "0.9rem note-sans-jp-medium";
          let textX = textNumX + Math.round((ctx.measureText(textNum).width)*1.7);
          ctx.fillText(text, textX, textNumY + textNumY/10);
          ctx.save();
        }
      }
    ],
		totalCCTVCnt: 0,
		totalAiCameraCnt: 0,
		deviceStatusLoading: false,
		deviceStatusData: {
			storeCnt: 0,
			uac: { online: 0, offline: 0 },
			uas: { online: 0, offline: 0 },
		},
	}),
	created() {
		const role = this.$store.getters.getRole;
		this.checkRole = this.roleCheck(role);
		this.authorities = this.$store.getters.getAuthorities;
  },
	mounted() {
		this.getDeviceStatus();
	},
	methods: {
		td(t) {
      return this.$t("lang.dashboard." + t);
    },
		async getDeviceStatus() {
			this.deviceStatusLoading = true;
			let params = {};
			await this.networkController.getDashboardDeviceStatusData(params)
			.then(async (res) => {
				console.log('%cDashboard Device Status\n', "color:#008DD0;", res.data);
				this.deviceStatusData = res.data;
				this.totalCCTVCnt = res.data.uac.online + res.data.uac.offline;
				this.$store.commit('setTotalCameraCount', this.totalCCTVCnt);
				this.totalAiCameraCnt = res.data.uas.online + res.data.uas.offline;
				this.cctvChartData.datasets[0].data = [res.data.uac.online, res.data.uac.offline];
				this.aiCameraChartData.datasets[0].data = [res.data.uas.online, res.data.uas.offline];
				if(this.checkRole == 'private' || this.checkRole == 'branch') {
					if(this.totalAiCameraCnt < 1) {
						this.$store.commit('setPrivateUserAnalytics', false);
					} else {
						this.$store.commit('setPrivateUserAnalytics', true);
					}
				}
				this.deviceStatusLoading = false;
			}).catch(error => {
				this.deviceStatusLoading = false;
			});
		},
	}
}
</script>

<style lang="scss" scoped>
#cctv_status_box {
	background-color: #34363C;
	// border: 1px solid #707070;
	color: white;
	border-radius: 5px;
}
#chart_box {
	position: relative;
}
</style>